import {
	Grid,
	GridColumn,
	useSnackbar,
} from "@livingdesign/react";
import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getService, getServiceWithResponseType } from "../../../axios/axios";
import { isCurrencyValueEmptyCheck, isValueEmptyCheck } from "../../../helpers/validationUtils";
import {ACTIONS, ADD_NEW_RATE, APPROVED_WALMART_RATE, APPROVING_ATTORNEY, CURRENT_STANDARD_RATE,
	DISCOUNT, END_DATE, JUSTIFICATION_FOR_RATE, MATTER_NUMBER,
  MSR_EDIT,
  MSR_EXPORT_SUCCESS_MSG,
  PROPOSED_WALMART_RATE, REACH_TO_OCM, REJECTION_COMMENT, REJECTION_REASON, REQUESTER_EMAIL, START_DATE, STATUS_ACTIVE,
  USER_STATUS_LABELS,
  SYS_ADMIN,
  OC_ADMIN
} from "../../../constants/constants";
import { setMatterSpecificRates } from "../../../store/actions/peopleAction";
import MatterSpecificRatesStyles from "./PeopleMatterSpecificRatesList.styles";
import { EXTERNAL_USER_SERVICE } from "../../../constants/baseURLs";
import { useHistory, useParams } from "react-router-dom";
import { getErrorMessage, getRejectionReason } from "../../../helpers/utils";
import { displayLocalDate } from "../../../helpers/utcUtils";
import MuiDataTable from "../../../components/Table/MuiDataTable/MuiDataTable";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import ActionPopover from "../../../components/Table/ActionPopover/ActionPopover";
import { formSearchQuery, getExportedData } from "../../../helpers/tableUtils";
import { Operations } from "../../../axios/operations";
import EditRateModal from "../../../components/Modal/EditRateModal/EditRateModal";
import InactivateRateModal from "../../../components/Modal/InactivateRateModal/InactivateRateModal";
import RateRequestStatus from "../Utils/RateRequestStatus";
import { UPDATE } from "../../../constants/actionButtons";
import ViewMatterPARateDetail from "../PeopleRates/ViewMatterPARateDetails";
import { amountFormat, getCurrencyAmount } from "../../../helpers/commonUtils";

/*
* This component is for displaying Matter Specific Rates associated with any user
*/

const PeopleMatterSpecificRatesList = (props) => {
	const accessibility = useSelector((state) => state?.accessibility?.applicationAccess?.organization?.tabs?.people?.tabs?.active?.details?.tabs?.matterSpecificRates);
	const status = useSelector(state => state?.people?.userDetail?.status);
	const classes = MatterSpecificRatesStyles();
	const userRequestId = useSelector((state) => state?.user?.userRequestId);
	const { identifier } = useSelector((state) => state?.organization?.organizationDetailValues);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const history = useHistory()
	const { peopleId } = useParams()
	const { addSnack } = useSnackbar();
	const { matterSpecificRates } = useSelector((state) => state?.people);
	const { userDetail } = useSelector((state) => state?.people)
	const masterDetails = useSelector(state => state?.masterData?.masterDatas);
	const [tableRowIndex, setTableRowIndex] = useState([]);
	const [filters, setFilters] = useState("");
	const [rateColumns, setRateColumns] = useState([]);
	const [editRateOpen, setEditRateOpen] = useState(false);
	const [exportLoading, setExportLoading] = useState(false);
	const [editRateId, setEditRateId] = useState(0);
	const [inactivateModalOpen, setInactivateModalOpen] = useState(false);
	const [inactivateRateId, setInactivateRateId] = useState(null);
	const [inactivateWarningMessage, setInactivateWarningMessage] = useState("");
	const {userDetail: currentUserDetail} = useSelector((state) => state?.user);
	const userRoles = currentUserDetail?.roleCode || [];
	const isOCOrADMIN =  userRoles?.includes(SYS_ADMIN) || userRoles?.includes(OC_ADMIN); 
	const actionItems = [
	{
		"actionId": 0,
		"label": "Inactivate",
		"isAboveDivider": true,
		"isDisabled": !isOCOrADMIN,
		"showAction": isOCOrADMIN
	}];

	const onClickOption = (selectedId, tableMeta) => {
		switch (selectedId) {
			case 0:
				const rateData = matterSpecificRates?.find(rate => rate.id === tableMeta?.rowData?.[15]);
				setInactivateRateId(tableMeta?.rowData?.[15]);
				checkIfOnlyActiveRate(rateData);
				break;
			default:
			  return null;
		}
	}

	useEffect(() => {
		COLUMNS.map((col)=>{col.options.setCellHeaderProps = () => ({
			style: { fontWeight: "bold", color: "black" }, 
		})})
		setRateColumns(COLUMNS);
		getMatterSpecificRates();
	}, [filters]);


	const FILTER_CONFIGS = [
	{
		colKey: "status",
		type: "checkbox",
		label: "Status",
		options: [
			"Active",
			"Expired",
			"Inactive",
			"Invalid",
			"Rejected",
			"Submitted",
		],
		defaultOpen: true,
		displayLabel: false,
		accordian: 'Status',
	},
    {
		colKey: "matterNumber",
		type: "matterDropdownAutocomplete",
		label: "Matter Number",
		defaultOpen: true,
		displayLabel: false,
		accordian: 'Matter Number',
		id: "matterNumber",
		isRestricted: false
    },
    {
		name: "currentWalmartRate",
		colKey: "currentWalmartRate",
		type: "textField",
		defaultOpen: true,
		displayLabel: false,
		accordian: 'Approved Rate',
    }
  ];

  	const handleExport = () => {
		setExportLoading(true);
		const csv = "csv=true";
		getServiceWithResponseType(EXTERNAL_USER_SERVICE, `/search/matter-specific-rates/v1?filter=(${defaultFilterCondition})&${csv}`, "arraybuffer")
		.then((response) => {
			const data = response?.data;
			const contentType = response?.headers?.["content-type"];
			getExportedData(data, contentType,'matter-specific-rates');
			addSnack({ message: MSR_EXPORT_SUCCESS_MSG });
		})
		.catch((error) => {
			addSnack({ message: getErrorMessage(error) });
		})
		.finally(() => {
			setExportLoading(false);
		});
	}

	const defaultFilterCondition = `${formSearchQuery(
		"isActive",
		Operations.EQ,
		true,
		'boolean'
	)}+${
	formSearchQuery(
		"userRequestId",
		Operations.EQ,
		userRequestId,
		'id'
	)}`;
	/*
	*Function to call User Request Service to fetch Matter Specific Rates
	*/
	const getMatterSpecificRates = () => {
		setLoading(true);
		const csv = "csv=false";
		getService(EXTERNAL_USER_SERVICE, `/search/matter-specific-rates/v1?filter=(${defaultFilterCondition}${filters})&${csv}`)
		.then((res) => {
			dispatch(setMatterSpecificRates(res?.data?.matterSpecificRates));
			setLoading(false);
		}).catch((error) => {
			addSnack({
			 message: getErrorMessage(error)
			});
			setLoading(false);
		});
	}

	const handleServerSideFilter = (filterQuery) => {
		setFilters(filterQuery);
	};

	const customOptions = {
		expandableRows: true,
		expandableRowsHeader: false,
		expandableRowsOnClick: true,
		serverSideSearchFilter: false,
		filterConfigs: FILTER_CONFIGS,
    	onServerSideFilter: handleServerSideFilter,
		isRowExpandable: (tableRowIndex, expandedRows) => {
		  return true;
		},
		rowsExpanded: tableRowIndex,
		renderExpandableRow: (rowData, rowMeta, updateValue) => {
		   return (
			<ViewMatterPARateDetail rowData={rowData} fromMatterSpecificRates={true} />
		  );
		},
		persistFilter: true,
		onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {},
		totalCount: matterSpecificRates?.count ?? 0,
			};

	/**
* Function will use for add New Rate
*/
	const addNewRate = () => {
		history.push(`/people/${userDetail?.userRequestId}/add-matter-specific-rate`, { fromMatterSpecificRates: true, peopleIdentifier: peopleId, organizationName: userDetail?.organizationName, userName:`${userDetail?.firstName} ${userDetail?.lastName}`, selectedTab:1 });
	}
	const renderApprovedRate=(value, tableMeta) => {
		return ( tableMeta?.rowData?.[4] === "Active" ? getCurrencyAmount(amountFormat(value)) : '-' )
	}

	const renderStatus = (value, tableMeta) => {
		return  <RateRequestStatus detail={{status: value}} />
	}

	const COLUMNS = [
		{
			name: "currentWalmartRate",
			label: APPROVED_WALMART_RATE,
			colKey: "currentWalmartRate",
			options: {
				sort: false,
				filter: true,
				customBodyRender: renderApprovedRate,
				customFilterListOptions: { render: (v) => `Approved Rate: ${getCurrencyAmount(amountFormat(parseInt((v))))}` },
				filterOptions: {
					logic: (value, filters) => {
					if (!filters[0]) return false;
					return value !== getCurrencyAmount(amountFormat(parseInt((filters[0]))));
					},
				},
			},
		},
		{
			name: "matterNumber",
			label: MATTER_NUMBER,
			colKey: "matterNumber",
			options: {
				sort: false,
				display: true,
				customFilterListOptions: { render: (v) => `Matter Number: ${v}` },
			},
		},
		{
			name: "startDate",
			label: START_DATE,
			colKey: "startDate",
			options: {
				sort: false,
				display: true,
				customBodyRender: (value) => (
					<Tooltip title={REACH_TO_OCM} placement="top">
						<span>{value ? displayLocalDate(value) : "-"} </span>
					</Tooltip>
				)
			},
		},
		{
			name: "endDate",
			label: END_DATE,
			colKey: "endDate",
			options: {
				sort: false,
				display: true,
				customBodyRender: (value) => (value ? displayLocalDate(value) : "-")
			},
		},
		{
			name: "status",
			label: "Status",
			colKey: "status",
			options: {
				sort: false,
				customBodyRender: renderStatus,
				customFilterListOptions: { render: (v) => `Status: ${v}` },

			},
		},
		{
			name: "actions",
			label: ACTIONS,
			colKey: "actions",
			options: {
				sort: false,
				customBodyRender: (value, tableMeta) => {
					return (
						<ActionPopover
							actionItems={tableMeta?.rowData?.[4] === "Active" ? actionItems : []}
							onClickOption={onClickOption}
							data-testid="action-btn"
							tableMeta={tableMeta}
						/>
					)
				},
			},
		},
		{
			name: "currentStandardRate",
			colKey: "currentStandardRate",
			options: {
				display: false
			},
		},	
		{
			name: "proposedWalmartRate",
			colKey: "proposedWalmartRate",
			options: {
				display: false
			},
		},	
		{
			name: "discount",
			colKey: "discount",
			options: {
				display: false
			},
		},
		{
			name: "walmartApprovingAttorneyFullName",
			colKey: "walmartApprovingAttorneyFullName",
			options: {
				display: false
			},
		},
		{
			name: "requesterEmailId",
			colKey: "requesterEmailId",
			options: {
				display: false
			},
		},
		{
			name: "outsideOrgJustification",
			colKey: "outsideOrgJustification",
			options: {
				display: false
			},
		},
		{
			name: "rejectReasonCategoryCode",
			colKey: "rejectReasonCategoryCode",
			options: {
				display: false
			},
		},
		{
			name: "rejectReasonDetails",
			colKey: "rejectReasonDetails",
			options: {
				display: false
			},
		},
		{
			name: "matterName",
			colKey: "matterName",
			options: {
				display: false
			},
		},
		{
			name: "id",
			colKey: "id",
			options: {
				display: false
			},
		},
		{
			name: "walmartApprovingAttorneyUserId",
			colKey: "walmartApprovingAttorneyUserId",
			options: {
				display: false
			},
		},
	];

	const checkIfOnlyActiveRate = (rateData) => {
		try {
			const activeRatesForMatter = matterSpecificRates?.filter(rate => 
				rate.status === "Active" && 
				rate.matterNumber === rateData?.matterNumber
			) || [];
			
			const activeRatesCount = activeRatesForMatter.length;
			
			const baseMessage = "Are you sure you want to inactivate this matter specific rate?";
			
			if (activeRatesCount === 1) {
				setInactivateWarningMessage(`${baseMessage}\n\nWarning: This is the only active rate for ${rateData?.matterNumber}. Inactivating this rate will leave no active rates for this matter.`);
			} else {
				setInactivateWarningMessage(baseMessage);
			}
			
			setInactivateModalOpen(true);
		} catch (error) {
			console.error("Error checking active rates:", error);
			setInactivateWarningMessage("Are you sure you want to inactivate this matter specific rate?");
			setInactivateModalOpen(true);
		}
	};

	return (
		<div data-testid="specific-rates-matter-container">
			<div className={classes.whiteContainer}>
				<MuiDataTable
					data={matterSpecificRates}
					columns={rateColumns}
					setTableColumns={setRateColumns}
					groupFilter={true}
					disableSearch={true}
					exportLoading={exportLoading}
					onExportClick={handleExport}
					customOptions={customOptions}
					hideAddNewButton={!(accessibility?.addNew && status?.toLowerCase() === STATUS_ACTIVE)}
					onAddNew={addNewRate}
					addNewLabel={ADD_NEW_RATE}
					disableAddNew = {status === USER_STATUS_LABELS.INACTIVE}
					loading={loading}
				/>	
				<EditRateModal
					open={editRateOpen}
					setOpen={setEditRateOpen}
					title={MSR_EDIT}
					editButtonText={UPDATE}
					fromMatterSpecificRates={true}
					editRateValues={matterSpecificRates?.filter((item)=>item.id === editRateId)[0]}
					getRates={getMatterSpecificRates}
				/>
				<InactivateRateModal
					open={inactivateModalOpen}
					setOpen={setInactivateModalOpen}
					rateId={inactivateRateId}
					rateType="matter-specific"
					warningMessage={inactivateWarningMessage}
					onSuccess={getMatterSpecificRates}
				/>
			</div>
		</div>
	)
}

export default PeopleMatterSpecificRatesList;
